import React, { useState, useEffect } from "react";
import { Button, Col, Flex } from "antd";
import { Typography, Grid, Stack, Chip } from "@mui/material";
import { useParams } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReContract from "assets/images/recontract.svg";
import { useAuth } from "../../../../hooks/useAuth";
import dayjs from "dayjs";

import api from "_api";

import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import CustomTable from "components/TableExplanded/Table";
import TableData from "../columns";
import useColumns from "../columns/detail/userColumns";

//ASSET
import Approved_icon from "assets/images/Approved.svg";
import waitting_icon from "assets/images/waitting.svg";
import notApproved_icon from "assets/images/noteApprove.svg";

import Modal from "components/Modal/SuperAdmin/create/createUser";
import ModalAddDate from "components/Modal/SuperAdmin/create/addDateCompanyPackage";
import { Link } from "react-router-dom";
import ModalViewPackageMarketPlace from "components/Modal/SuperAdmin/view/viewPackageMarketplace";

const Detail = () => {
  const [approvedActive, setApprovedActive] = useState(false);
  const [isApproved, setIsApproved] = useState(0);
  const [companyData, setCompanyData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [marketplace, setMarketplace] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [companyUsePackage, setCompanyUsePackage] = useState([]);
  const [isAddDateOpen, setIsAddDateOpen] = useState(false);
  const [packageTypeActive, setPackageTypeActive] = useState(null);
  const [companyPackageActive, setCompanyPackageActive] = useState(null);
  const [isPackageMarketPlaceActive, setIsPackageMarketPlaceActive] =
    useState(false);
  const [packageMarketplaceData, setPackageMarketplaceData] = useState(null);
  const [billDebtData, setBillDebtData] = useState([]);

  const { role } = useAuth();

  let params = useParams();
  const [marketplaceHeader] = useState([
    { label: "ชื่อแพ็คเกจ" },
    { label: "เครดิตทั้งหมด" },
    { label: "ยอดคงเหลือ" },
    { label: "วันที่เริ่มต้น" },
    { label: "สถานะ" },
    { label: "" },
  ]);

  const [companyUsePackageHeader] = useState([
    { label: "ประเภท" },
    { label: "การใช้งาน" },
    { label: "วันหมดอายุ" },
    { label: "" },
  ]);

  const BillDebt = [
    {
      label: "เลขที่ใบแจ้งหนี้",
    },
    { label: "เลขที่ใบเสร็จรับเงิน" },
    { label: "ยอดเงิน" },
    { label: "พิมพ์ใบแจ้งหนี้" },
    { label: "พิมพ์ใบเสร็จรับเงิน" },
    { label: "" },
  ];

  const fetchCompanyData = async (id) => {
    const result = await api.super_admin.getCompanyData(id);
    const companyPackageData = await result?.data?.CompanyPackages?.filter(
      (item) => item.company_package_id == params.package_id
    );

    if (result.isStatus) {
      setIsApproved(companyPackageData ? companyPackageData[0]?.approved : 0);

      setCompanyData([
        { label: "รหัส MID", data: result?.data?.mid },
        { label: "ชื่อร้าน", data: result?.data?.company_name },
        { label: "เลขประจำตัวผู้เสียอากร", data: result?.data?.tax_id_number },
        {
          label: "ชื่อเจ้าของร้าน/ผู้ทำธุรกรรม",
          data: result?.data?.owner_name,
        },
        { label: "ชื่อผู้ติดต่อ", data: result?.data?.contact },
        { label: "เบอร์โทรศัพท์", data: result?.data?.phone },
        { label: "อีเมล", data: result?.data?.email },
        { label: "สถานะ", data: result?.data?.company_status },
        {
          label: "โลโก้",
          data: (
            <img
              src={`${result?.data?.company_logo ?? null}`}
              alt="logo"
              style={{
                aspectRatio: "1/1",
                objectFit: "cover",
                width: "75px",
                height: "75px",
              }}
            />
          ),
        },
      ]);

      setAddressData([
        { label: "อาคาร", data: result?.data?.building ?? "-" },
        { label: "ที่อยู่", data: result?.data?.alley ?? "-" },
        { label: "ถนน", data: result?.data?.road ?? "-" },
        { label: "ตำบล/แขวง", data: result?.data?.amphure ?? "-" },
        { label: "อำเภอ/เขต", data: result?.data?.district ?? "-" },
        { label: "จังหวัด", data: result?.data?.province ?? "-" },
        { label: "รหัสไปรษณีย์", data: result?.data?.zipcode ?? "-" },
      ]);

      const updatedUserData =
        result?.data?.Users.map((item) => ({
          id: item.user_id,
          username: item.username,
          name: item.name,
          role: item.Role.name,
          status: item.status,
          user_approved: item.approved,
        })) ?? [];

      setUserData(updatedUserData);
    }
  };

  const fetchUsePackage = async () => {
    const response = await api.super_admin.getCompanyUsePackage(
      params.company_id
    );

    const rankedFilter = response?.data.filter((item) => item.ranks == null);

    const sortData = rankedFilter.map((item) => ({
      package_name: item.package_name,
      is_used: (
        <Chip
          label={item.is_used ? "ใช้งาน" : "ไม่ใช้งาน"}
          style={{
            width: "100px",
            background: `${item.is_used ? "green" : "red"}`,
            color: "white",
            textTransform: "capitalize",
          }}
        />
      ),
      date_expire: item.date_expire
        ? dayjs(item.date_expire).format("DD/MM/YYYY")
        : "-",
      action: (
        <div
          onClick={() => {
            setIsAddDateOpen(true);
            setPackageTypeActive(item.package_type_id);
            setCompanyPackageActive(item.company_package_id);
          }}
          style={{ cursor: "pointer" }}
        >
          <img
            src={ReContract}
            alt="logo"
            style={{
              aspectRatio: "1/1",
              objectFit: "cover",
              width: "15px",
              height: "15px",
            }}
          />
        </div>
      ),
    }));
    setCompanyUsePackage(sortData);
  };

  const fetchMarketPlaceCompany = async (id) => {
    const result = await api.super_admin.getCompanyMarketPlace(id);
    console.log("result", result);

    const updatedMarketplace =
      result?.data?.map((item) => ({
        package_name: item.name_package,
        total_credit: item.total_credit,
        total_credit_remain: item.total_credit_remain,
        start_date: item.start_date,
        status: (
          <Stack direction="row" spacing={1}>
            <img
              src={getMarketplacePackage(item.status).icon}
              alt="status icon"
            />
          </Stack>
        ),
        action: (
          <Flex gap={5}>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsPackageMarketPlaceActive(true);
                setPackageMarketplaceData(item);
              }}
            >
              <VisibilityIcon color="primary" />
            </div>
            <div>
              <DeleteIcon color="error" />
            </div>
          </Flex>
        ),
      })) ?? [];
    setMarketplace(updatedMarketplace);
  };

  const fetchBillDebt = async (company) => {
    console.log(company, "fetch bill debt");

    const result = await api.super_admin.getBillDebt(company);
    console.log("billdebt", result);

    const newData = result?.data.map((data, key) => {
      return {
        invoice: data.start_date,
        receipt: data.start_date,
        balance: data.service_fee,
        printinvoice: (
          <Flex
            align="center"
            gap={5}
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_BASE_URL}/manage/pdf-bill/${data.id}`
              );
            }}
            style={{ cursor: "pointer" }}
          >
            <ReceiptIcon /> ใบแจ้งหนี้
          </Flex>
        ),
        printreceipt: (
          <Flex align="center" gap={5} style={{ cursor: "pointer" }}>
            <ReceiptIcon /> ใบเสร็จรับเงิน
          </Flex>
        ),
      };
    });
    setBillDebtData(newData);
  };
  useEffect(() => {
    fetchCompanyData(params.company_id);
    fetchMarketPlaceCompany(params.company_id);
    fetchBillDebt(params.company_id);
    fetchUsePackage();
  }, []);

  const columns = useColumns();

  const getMarketplacePackage = (approved) => {
    switch (approved) {
      case "approved":
        return {
          label: "Approved",
          color: "green",
          icon: Approved_icon,
        };
      case "pending":
        return {
          label: "Waitting",
          color: "orange",
          icon: waitting_icon,
        };
      default:
        return {
          label: "Not Approved",
          color: "red",
          icon: notApproved_icon,
        };
    }
  };

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleApprovedCompany = async (status) => {
    await api.super_admin.approvedCompanyPackage(params.package_id, {
      status: status,
    });
    setIsApproved(status);
    setApprovedActive(false);
  };

  return (
    <div style={{ padding: 0 }}>
      <Flex justify="space-between">
        <GradientButtonOutline
          variant="outlined"
          onClick={() => window.history.back()}
        >
          กลับ
        </GradientButtonOutline>
        <div>
          <Flex gap={5} align="center">
            {approvedActive && (
              <Flex justify="space-between" gap={5}>
                <Button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  className="btn-approved"
                  onClick={async () => {
                    await handleApprovedCompany(1);
                  }}
                >
                  <img
                    src={Approved_icon}
                    alt="approved_icon"
                    className="w-5 h-5"
                  />
                </Button>
                <Button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  className="btn-deny"
                  onClick={async () => {
                    await handleApprovedCompany(2);
                  }}
                >
                  <img
                    src={notApproved_icon}
                    alt="notapproved_icon"
                    className="w-5 h-5"
                  />
                </Button>
              </Flex>
            )}

            <GradientButtonOutline
              onClick={() => setApprovedActive(!approvedActive)}
              disabled={role == "SuperAdminM"}
            >
              {isApproved == 0
                ? "รอผลการตรวจสอบ"
                : isApproved == 1
                ? "อนุมัติแล้ว"
                : "ไม่อนุมัติ"}
            </GradientButtonOutline>
          </Flex>
        </div>
      </Flex>

      <Flex gap="large" style={{ marginTop: "10px" }}>
        <Col span={12}>
          <div>
            <TableData
              headers={[{ label: "รายละเอียดร้านค้า" }]}
              datas={companyData}
              isTable={false}
            />
          </div>
          <div>
            <Typography
              component="div"
              style={{ fontSize: "16px", fontWeight: "bolder" }}
            >
              สัญญาการใช้งาน
            </Typography>
            <TableData
              headers={companyUsePackageHeader}
              datas={companyUsePackage}
              isTable={true}
            />
          </div>
          <div>
            <Typography
              component="div"
              style={{ fontSize: "16px", fontWeight: "bolder" }}
            >
              แพ็คเกจ MarketPlace
            </Typography>
            <TableData
              headers={marketplaceHeader}
              datas={marketplace}
              isTable={true}
            />
          </div>
        </Col>
        <Col span={11}>
          <div>
            <TableData
              headers={[{ label: "ที่ตั้ง" }]}
              datas={addressData}
              isTable={false}
            />
          </div>
          <Flex
            justify="space-between"
            align="center"
            style={{ marginBottom: "10px" }}
          >
            <Typography
              component="div"
              style={{ fontSize: "16px", fontWeight: "bolder" }}
            >
              ผู้ใช้งาน
            </Typography>
            {(role === "SuperAdminM" || role === "admin") && (
              <GradientButton onClick={handleModalOpen}>
                สร้างผู้ใช้งาน
              </GradientButton>
            )}
          </Flex>
          <CustomTable
            columns={columns}
            data={userData}
            fetchData={() => fetchCompanyData(params.company_id)}
          />
        </Col>
      </Flex>
      <Col>
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: "10px" }}
        >
          <Typography
            component="div"
            style={{ fontSize: "16px", fontWeight: "bolder" }}
          >
            ใบเสร็จรับเงิน
          </Typography>
          <Link to={`/admin/company/create-invoice/${params.company_id}`}>
            <GradientButton>สร้างใบแจ้งหนี้</GradientButton>
          </Link>
        </Flex>
        <TableData headers={BillDebt} datas={billDebtData} isTable={true} />
      </Col>

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={() => fetchCompanyData(params.company_id)}
        companyId={params.company_id}
      />

      <ModalAddDate
        open={isAddDateOpen}
        onClose={() => setIsAddDateOpen(!isAddDateOpen)}
        companyId={params.company_id}
        package_type_id={packageTypeActive}
        company_package_id={companyPackageActive}
        fetchProductData={fetchUsePackage}
        setPackageTypeActive={setPackageTypeActive}
      />

      <ModalViewPackageMarketPlace
        open={isPackageMarketPlaceActive}
        onClose={() =>
          setIsPackageMarketPlaceActive(!isPackageMarketPlaceActive)
        }
        selectedProduct={packageMarketplaceData}
        fetchProductData={() => fetchMarketPlaceCompany(params.company_id)}
      />
    </div>
  );
};

export default Detail;
